import { api } from './client';

export interface Task {
  id: string;
  type: string;
  text: string;
  sub: string | null;
  done: boolean;
  createdAt: string;
}

export interface CreateTaskInput {
  text: string;
  sub?: string | null;
}

export interface UpdateTaskInput {
  text?: string;
  sub?: string | null;
  done?: boolean;
}

export const tasksApi = {
  list: (openOnly = false) => api.get<Task[]>('/tasks', { query: { openOnly } }),
  create: (body: CreateTaskInput) => api.post<Task>('/tasks', body),
  update: (id: string, body: UpdateTaskInput) => api.patch<Task>(`/tasks/${id}`, body),
  remove: (id: string) => api.delete<void>(`/tasks/${id}`),
};
